export default "__VITE_ASSET__suNMk0eN__"